import { render, staticRenderFns } from "./ChatRecord.vue?vue&type=template&id=62268d2a&scoped=true"
import script from "./ChatRecord.vue?vue&type=script&lang=js"
export * from "./ChatRecord.vue?vue&type=script&lang=js"
import style0 from "./ChatRecord.vue?vue&type=style&index=0&id=62268d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62268d2a",
  null
  
)

export default component.exports